import { CategoryManagerService } from "@/services/category-manager";
import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import CategoryManagerState from "@/modules/category-manager";

export const CategoryMangerResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const categoryModule = getModule(CategoryManagerState);
	const actions: Promise<void>[] = [];

	actions.push(categoryModule.fetchCategories());
	actions.push(categoryModule.fetchLessonPlanVersionsOfCurrentVersionGroup());
	actions.push(categoryModule.getVCSLevelUnits());
	await Promise.all(actions);
	next();
};
